import React from 'react';
import './PlanCard.css';

export interface Plan {
  id: string;
  title: string;
  price: string;
  total?: string;
  discount?: string;
  isPopular?: boolean;
  amountInCents: number;
}

// 2. Usamos la interface 'Plan' aquí
interface PlanCardProps {
  plan: Plan; // Usamos el tipo explícito
  isProcessing: boolean;
  onSelectPlan: (plan: Plan) => void; // La función espera un objeto de tipo Plan
}

const PlanCard: React.FC<PlanCardProps> = ({ plan, isProcessing, onSelectPlan }) => {
  const buttonText = plan.id === 'free' ? 'Registrarse Gratis' : 'Seleccionar Plan';
  return (
    <div className={`plan-card ${plan.isPopular ? 'popular' : ''} ${plan.id === 'free' ? 'free-plan' : ''}`}>
      {plan.isPopular && <div className="popular-badge">Más Popular</div>}
      <h3>{plan.title}</h3>
      <div className="price">{plan.price}</div>
      {plan.total && <div className="detail">Total: <s>{plan.total}</s></div>}
      {plan.discount && <div className="detail discount">Descuento: {plan.discount}</div>}
      <button 
        className="action-button" 
        onClick={() => onSelectPlan(plan)}
        disabled={isProcessing}
      >
        {isProcessing ? 'Procesando...' : buttonText}
      </button>
    </div>
  );
};

export default PlanCard;